module.exports = __webpack_public_path__ + "img/screen-manual-5.834a6064.png";